export enum MoodEnum {
    VerySad = 0,
    Sad = 1,
    Meh = 2,
    Happy = 3,
    VeryHappy = 4
  }
  